export default __webpack_public_path__ + "static/media/brand_img03.94524425.png";